import { useEnvironment as n } from "../../../common/hooks/environment/useEnvironment.js";
import { useMutation as r } from "react-query";
function a() {
  const {
    servicesBaseUrl: t
  } = n();
  return r(
    async (e) => {
      try {
        await fetch(`${t}/analytics/shop-event/`, {
          method: "POST",
          body: JSON.stringify(e),
          headers: {
            "Content-Type": "application/json"
          }
        });
      } catch (o) {
        console.error(o);
      }
    }
  );
}
export {
  a as useAnalyticsShop
};
//# sourceMappingURL=useAnalyticsShop.js.map
